import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

function BotonNuevo(props) {
  return (
    <Link to={`/nuevo/${props.link}`}>
      <Button
        icon="add"
        circular
        color="pink"
        floated={props.floated}
        content={props.buttonText}
      />
    </Link>
  );
}

BotonNuevo.defaultProps = {
  floated: "left",
  buttonText: null
};

BotonNuevo.propTypes = {
  link: PropTypes.string.isRequired,
  floated: PropTypes.oneOf(["left", "right"]),
  buttonText: PropTypes.string
};

export default BotonNuevo;



// WEBPACK FOOTER //
// ./src/pages/shared/botones/BotonNuevo.jsx